import { render, staticRenderFns } from "./SocketText.vue?vue&type=template&id=78ad2540&scoped=true"
import script from "./SocketText.vue?vue&type=script&lang=js"
export * from "./SocketText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad2540",
  null
  
)

export default component.exports